import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify/vuetify';
import VueRouter from 'vue-router';
import routes from './routes/index';
import store from './store';
import VueFirestore from 'vue-firestore';
import * as VeeValidate from 'vee-validate';
import VueGtag from "vue-gtag";

Vue.use(VueFirestore);
Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueGtag, {
  config: { id: "UA-78710583-2" }
});



Vue.config.productionTip = false;
Vue.config.devtools = true;

const router = new VueRouter({
  mode: 'history',
  routes,
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
